import * as reducersConfigurationDefault from 'app/factory-default';
export const reducersConfiguration = reducersConfigurationDefault;
